module.exports = __webpack_public_path__ + "static/media/red-download-arrow.febe08c7.svg";